import type { SettingsModalType } from '@/helpers/settingsModal';
import { Tooltip, Trigger } from '@wegic/ui'
import '@wegic/ui/dist/components/Tooltip/index.css';;
import classNames from 'classnames';
import { useState } from 'react';
import Avatar from '@/components/Avatar';
import MobileBottomSheet from '@/components/MobileBottomSheet';
import UserMenu from '@/components/UserMenu';
import { isMobile } from '@/const/browser';
import { useUserStore } from '@/stores/user';
import styles from './index.module.less';

interface UserButtonProps {
  collapsed: boolean;
  settingsType: SettingsModalType;
}

function UserButton(props: UserButtonProps) {
  const { collapsed, settingsType } = props;
  const [visible, setVisible] = useState(false);
  const userInfo = useUserStore(state => state.userInfo);
  const userName = userInfo?.userName || 'User 1';
  const avatarUrl = userInfo?.userImage || '';

  const userButton = (
    <button
      className={classNames(styles['user-button'], {
        [styles['user-button-open']]: visible,
        [styles['user-button-collapsed']]: collapsed,
      })}
      type="button"
      aria-haspopup="menu"
      aria-expanded={visible}
    >
      <Avatar image={avatarUrl} name={userName} size={28} hasHover={false} />
      <span className={styles['user-name']}>{userName}</span>
    </button>
  );

  const userMenu = <UserMenu onClose={() => setVisible(false)} settingsType={settingsType} />;

  if (isMobile) {
    return (
      <>
        <button
          className={classNames(styles['user-button'], {
            [styles['user-button-open']]: visible,
            [styles['user-button-collapsed']]: collapsed,
          })}
          type="button"
          aria-haspopup="menu"
          aria-expanded={visible}
          onClick={() => setVisible(nextVisible => !nextVisible)}
        >
          <Avatar image={avatarUrl} name={userName} size={28} hasHover={false} />
          <span className={styles['user-name']}>{userName}</span>
        </button>
        <MobileBottomSheet visible={visible} ariaLabel={userName} onClose={() => setVisible(false)}>
          {userMenu}
        </MobileBottomSheet>
      </>
    );
  }

  return (
    <Trigger
      trigger="click"
      position="tl"
      popupAlign={{ top: 4 }}
      popupVisible={visible}
      boundaryDistance={{ left: 10, bottom: 10 }}
      onVisibleChange={setVisible}
      popup={() => userMenu}
      updateOnScroll
    >
      {collapsed ? (
        <Tooltip content={userName} position="right" triggerProps={{ mouseEnterDelay: 200 }}>
          {userButton}
        </Tooltip>
      ) : userButton}
    </Trigger>
  );
}

export default UserButton;
